import angular from 'angular'

import changeBillingAddressModal from './modal/change-billing-address-modal'
import changeEmailModal from './modal/change-email-modal'
import changeSelectedPaymentMethodModal from './modal/change-selected-payment-method-modal'
import changeMobileModal from './modal/change-mobile-modal'
import changePasswordModal from './modal/change-password-modal'
import deleteCreditCardModal from './modal/delete-credit-card-modal'
import deleteMandateModal from './modal/delete-mandate-modal'
import personalInformationDetail from './component/personalInformationDetail'
import personalInfoSponsorLink from './component/personalInfoSponsorLink'
import personalInformationCtrl from './personalInformation'

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
export default angular
.module('unergie.personalInformation', [])
.component('changeBillingAddressModal', changeBillingAddressModal)
.component('changeEmailModal', changeEmailModal)
.component('changeSelectedPaymentMethodModal', changeSelectedPaymentMethodModal)
.component('changeMobileModal', changeMobileModal)
.component('changePasswordModal', changePasswordModal)
.component('deleteCreditCardModal', deleteCreditCardModal)
.component('deleteMandateModal', deleteMandateModal)
.directive('personalInformationDetail', personalInformationDetail)
.directive('personalInfoSponsorLink', personalInfoSponsorLink)
.controller('personalInformationCtrl', personalInformationCtrl)
.name



// WEBPACK FOOTER //
// ./src/states/personalInformation/personalInformation.module.js